import styled from "styled-components";
import Loading from "../../components/Loading";
import { RenderFields } from "../../utils/form.utils";

export default function MoneyReceiptSection({
  loading,
  setValue,
  fields,
  control,
  watch,
  errors,
  unregister,
  children
}) {
  return (
    <Section className="rounded p-3 my-3">
      {children}
      <Loading loading={loading} />
      <RenderFields
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        unregister={unregister}
      />
    </Section>
  );
}

const Section = styled.div`
  background-color: #f8f9fa;
`;
